module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/je-e1bb30f3c6be27ba0bc425574ed802bb.svg";